import { Helmet } from "react-helmet";

const PageName = ({ title }) => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Tech Micro | {title}</title>
            </Helmet>
        </>
    );
}

export default PageName;
